import { Box, Stack, Title, Text } from '@mantine/core'
import { ReactComponent as IcEnvelop } from '@/assets/icon/envelope.svg'
import { SubscribeForm } from '@/components/widgets/SubscribeForm'
import styles from './SubscribeBlocks.module.css'

interface SubscribeNewsletterProps {
  /** Override the HubSpot form GUID if this band should use a different form. */
  formId?: string
}

/**
 * Bottom-of-page newsletter band. Rendered at the layout level, OUTSIDE the
 * max-width container, so it spans the full viewport width via `w="100%"`.
 * Keeps `darkForm` (light text over the dark background) and `formSlot`.
 */
export const SubscribeNewsletter = ({ formId }: SubscribeNewsletterProps) => {
  return (
    <Box w="100%" className={styles.darkForm} bg="#054484" py={48} px="lg">
      <Stack gap={8} align="center" ta="center" maw={680} mx="auto" w="100%">
        <IcEnvelop style={{ width: 48, height: 48, color: '#fff' }} />

        <Title order={2} c="white" fz={{ base: 26, md: 26 }} fw={700}>
          Get Weekly ETF Insights
        </Title>

        <Text c="#BFDFFF" opacity={0.85} maw={620}>
          Join 50,000+ Canadian investors receiving expert ETF analysis, market updates, and portfolio tips every week.
        </Text>

        <Box w="100%" maw={520} mt="2xs">
          <SubscribeForm formId={formId} buttonLabel="Subscribe" buttonVariant="light" />
        </Box>

        <Text c="#BFDFFF" opacity={0.7} fz="sm">
          No spam. Unsubscribe anytime. We respect your privacy.
        </Text>
      </Stack>
    </Box>
  )
}

export default SubscribeNewsletter
